module.exports = __webpack_public_path__ + "img/loader-white.f8b0076b.gif";